import { useState, useCallback } from 'react';
import { useGateway } from './useGateway';
import { ContactFormData, ContactResponse } from '../api/services/contactService';

/**
 * Hook for contact form operations using the service-based architecture
 */
export const useContactService = () => {
  const { gateway, handleRequest, isLoading, error } = useGateway();
  const [response, setResponse] = useState<ContactResponse | null>(null);

  /**
   * Submit contact form
   */
  const submitContactForm = useCallback(async (formData: ContactFormData): Promise<ContactResponse | null> => {
    const result = await handleRequest(() => gateway.contact.submitContactForm(formData));
    
    if (result) {
      setResponse(result);
      return result;
    }
    
    return null;
  }, [gateway.contact, handleRequest]);

  /**
   * Clear response data
   */
  const clearResponse = useCallback(() => {
    setResponse(null);
  }, []);

  return {
    response,
    isLoading,
    error,
    submitContactForm,
    clearResponse
  };
};
